import * as yup from 'yup';
import { CertificationsSchema, EducationSchema, ExperienceSchema } from './ResumeSchemas';

//Schemas
export const TalentProfileSchema = yup.object().shape({
    Specialization: yup.string().required(),
    PrimaryExpertise: yup.string().required(),
    SecondaryExpertise: yup.string(),
    TertiaryExpertise: yup.string(),
    PrimaryLanguage: yup.string().required(),
    SecondaryLanguage: yup.string(),
    Summary: yup.string().required().max(5000, 'Text must be 5000 characters or less'),
    Skills: yup.array().of(yup.string()).required(),
    Certifications: yup.array().of(CertificationsSchema).required(),
    Education: yup.array().of(EducationSchema).required(),
    Experience: yup.array().of(ExperienceSchema).required(),
    Portfolio: yup.array().of(yup.string()).required()
});

//Types
export type TalentProfileType = yup.InferType<typeof TalentProfileSchema>


